// Simple polyfill for process global
if (typeof process === 'undefined') {
  global.process = {
    env: {
      NODE_ENV: 'development',
      REACT_APP_DEFAULTAUTH: 'fake',
      PUBLIC_URL: ''
    }
  };
}
